module.exports = __webpack_public_path__ + "img/cipamingkis.82cfc2a5.svg";